import React, { useState } from "react";
import { MultiSelect } from "primereact/multiselect";
// import AddNewMember from "./AddNewMember"; // temporarily disabled
import UserManagement from "./UserManagement";

export const multiSelectFilter = (options, key, data) => {
  const uniqueOptions = Array.from(new Set(data?.map((user) => user[key])));

  return (
    <MultiSelect
      value={options.value}
      options={uniqueOptions?.map((user) => ({ label: user, value: user }))}
      itemTemplate={(option) => <span>{option.label}</span>}
      onChange={(e) => options.filterApplyCallback(e.value)}
      optionLabel="label"
      placeholder="Any"
      className="p-column-filter"
      maxSelectedLabels={1}
      style={{ minWidth: "10rem" }}
    />
  );
};

function AccessManagement() {
  const [enableNewMemberPopUp, setEnableNewMemberPopUp] = useState(false);

  return (
    <div className="bg-[#f9fafb]">
      <div className="flex flex-col pt-4 px-4 pb-1 ">
        <h1 className="text-[24px] font-bold">User Management</h1>
        <div>Ensuring the Right Access for the Right People</div>
      </div>
      <UserManagement setEnableNewMemberPopUp={setEnableNewMemberPopUp} />
      {/* AddNewMember temporarily disabled
      {enableNewMemberPopUp && (
        <AddNewMember onHide={() => setEnableNewMemberPopUp(false)} />
      )} */}
    </div>
  );
}

export default AccessManagement;



